import * as types from '../mutation-types'
import * as api from '../api'
import moment from 'moment'

const state = {
  default_schedule: {
    weeks: 0,
    default_schedule_days: []
  }
}

const getters = {
  getDefaultSchedule: state => state.default_schedule
}

const actions = {
  getDefaultSchedule ({ commit, rootState }) {
    api.instance.get('default_schedule/' + rootState.appWide.scoped_site_id)
      .then(function (response) {
        const defaultSchedule = response.data.default_schedule
        if (defaultSchedule.start_date === null) {
          defaultSchedule.start_date = new Date()
        } else {
          defaultSchedule.start_date = moment(defaultSchedule.start_date).toDate()
        }
        commit(types.RECEIVE_DEFAULT_SCHEDULE, defaultSchedule)
      })
  },
  editDefaultSchedule ({ commit, rootState }, defaultSchedule) {
    api.instance.put('default_schedule/' + rootState.appWide.scoped_site_id, defaultSchedule)
      .then(function (response) {
        alert('Saved successfully!')
      })
  }
}

const mutations = {
  [types.RECEIVE_DEFAULT_SCHEDULE] (state, defaultSchedule) {
    state.default_schedule = defaultSchedule
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
